// imports
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Tooltip } from '@mui/material';
import StraightenIcon from '@mui/icons-material/Straighten';

// local imports
import { uiActions, RootState } from '../../../store';
import CustomButton from '../../CustomButton';
import { sharedTooltipProps } from '../CustomMapControls/sharedTooltipProps';
import { FOCUS_BLUE } from '../../../constants/colors';

/**
 * MapRulerButton
 *
 * Renders a button that toggles the map ruler tool for measuring distance between two points.
 *
 * @returns {JSX.Element} The rendered MapRulerButton component.
 */
const MapRulerButton = React.memo(function MapRulerButton() {
  const dispatch = useDispatch();
  const rulerActive = useSelector((state: RootState) => state.ui.rulerActive);

  const handleClick = () => {
    dispatch(uiActions.toggleRuler());
  };

  return (
    <Tooltip
      title={rulerActive ? 'Stop measuring' : 'Measure distance'}
      placement="left"
      {...sharedTooltipProps}
    >
      <CustomButton
        data-testid="map-ruler-button"
        aria-label="Measure distance"
        aria-pressed={rulerActive}
        onClick={handleClick}
        buttonVariant="standalone"
        sx={
          rulerActive
            ? { border: `2px solid ${FOCUS_BLUE} !important`, backgroundColor: '#e8f2ff !important' }
            : undefined
        }
      >
        <StraightenIcon />
      </CustomButton>
    </Tooltip>
  );
});

export default MapRulerButton;
